import ILUMA_I2_EXPERIENCES_IMAGE from '../assets/images/devices/iluma-i2/PROTECTED-ILUMA_I2_experiences.webp';
import ILUMA_I2_HOLDER_IMAGE from '../assets/images/devices/iluma-i2/PROTECTED-ILUMA_I2_HOLDER.webp';
import ILUMA_I2_IQOS_LOGO_IMAGE from '../assets/images/devices/iluma-i2/PROTECTED-ILUMA_I2_iqos_logo.webp';
import ILUMA_I2_LTE_SEARCHING_IMAGE from '../assets/images/devices/iluma-i2/PROTECTED-ILUMA_I2_lte_searching.webp';
import ILUMA_I2_OPEN_APP_IMAGE from '../assets/images/devices/iluma-i2/PROTECTED-ILUMA_I2_open_app.webp';
import ILUMA_I2_PRESS_BUTTON_IMAGE from '../assets/images/devices/iluma-i2/PROTECTED-ILUMA_I2_press_button.webp';
import ILUMA_I2_PROGRESS_25_IMAGE from '../assets/images/devices/iluma-i2/PROTECTED-ILUMA_I2_progress_25.webp';
import ILUMA_I2_PROGRESS_50_IMAGE from '../assets/images/devices/iluma-i2/PROTECTED-ILUMA_I2_progress_50.webp';
import ILUMA_I2_PROGRESS_75_IMAGE from '../assets/images/devices/iluma-i2/PROTECTED-ILUMA_I2_progress_75.webp';
import ILUMA_I2_PROGRESS_99_IMAGE from '../assets/images/devices/iluma-i2/PROTECTED-ILUMA_I2_progress_99.webp';
import ILUMA_I2_TURNED_OFF_IMAGE from '../assets/images/devices/iluma-i2/PROTECTED-ILUMA_I2_turned_off.webp';
import ILUMA_I2_WIFI_SEARCHING_IMAGE from '../assets/images/devices/iluma-i2/PROTECTED-ILUMA_I2_wifi_searching.webp';
import ILUMA_I5_CHECKMARK_IMAGE from '../assets/images/devices/iluma-i5/PROTECTED-ILUMA_I5_checkmark.webp';
import ILUMA_I5_TURNED_OFF_IMAGE from '../assets/images/devices/iluma-i5/PROTECTED-ILUMA_I5_turned_off.webp';
import ILUMA_I5_TURNED_ON_IMAGE from '../assets/images/devices/iluma-i5/PROTECTED-ILUMA_I5_turned_on.webp';
import ILUMA_I5_USER_IMAGE from '../assets/images/devices/iluma-i5/PROTECTED-ILUMA_I5_user.webp';
import deviceScreenTypes from '../consts/device/deviceScreenTypes';
import deviceTypes from '../consts/device/deviceTypes';

const deviceImagesConfig = {
    [deviceTypes.ILUMA_I2_CHARGER]: {
        [deviceScreenTypes.WIFI_SEARCHING]: ILUMA_I2_WIFI_SEARCHING_IMAGE,
        [deviceScreenTypes.LTE_SEARCHING]: ILUMA_I2_LTE_SEARCHING_IMAGE,
        [deviceScreenTypes.OPEN_APP]: ILUMA_I2_OPEN_APP_IMAGE,
        [deviceScreenTypes.PRESS_BUTTON]: ILUMA_I2_PRESS_BUTTON_IMAGE,
        [deviceScreenTypes.PROGRESS_25]: ILUMA_I2_PROGRESS_25_IMAGE,
        [deviceScreenTypes.PROGRESS_50]: ILUMA_I2_PROGRESS_50_IMAGE,
        [deviceScreenTypes.PROGRESS_75]: ILUMA_I2_PROGRESS_75_IMAGE,
        [deviceScreenTypes.PROGRESS_99]: ILUMA_I2_PROGRESS_99_IMAGE,
        [deviceScreenTypes.EXPERIENCES]: ILUMA_I2_EXPERIENCES_IMAGE,
        [deviceScreenTypes.TURNED_OFF]: ILUMA_I2_TURNED_OFF_IMAGE,
        [deviceScreenTypes.IQOS_LOGO]: ILUMA_I2_IQOS_LOGO_IMAGE,
        [deviceScreenTypes.DEFAULT]: ILUMA_I2_EXPERIENCES_IMAGE,
    },
    [deviceTypes.ILUMA_I2_HOLDER]: {
        [deviceScreenTypes.DEFAULT]: ILUMA_I2_HOLDER_IMAGE,
    },
    [deviceTypes.ILUMA_I5_CHARGER]: {
        [deviceScreenTypes.USER]: ILUMA_I5_USER_IMAGE,
        [deviceScreenTypes.CHECKMARK]: ILUMA_I5_CHECKMARK_IMAGE,
        [deviceScreenTypes.TURNED_OFF]: ILUMA_I5_TURNED_OFF_IMAGE,
        [deviceScreenTypes.TURNED_ON]: ILUMA_I5_TURNED_ON_IMAGE,
        [deviceScreenTypes.DEFAULT]: ILUMA_I5_TURNED_OFF_IMAGE,
    },
    [deviceTypes.ILUMA_I5_HOLDER]: {},
};

export default deviceImagesConfig;
